import axios from "axios";
import { API_URL } from "../config";
import WebApp from "@twa-dev/sdk";

export const checkAndUpdateUserInfo = async (tgUser, response) => {
  const APIKey = process.env.REACT_APP_API_KEY;
  if (
    tgUser.first_name !== response.data.firstName ||
    tgUser.last_name !== response.data.lastName ||
    tgUser.username !== response.data.username ||
    tgUser.isPremium !== response.data.isPremium
  ) {
    try {
      const updatedUser = await axios.put(
        `${API_URL}/api/user/${tgUser.id}`,
        {
          firstName: tgUser.first_name,
          lastName: tgUser.last_name,
          username: tgUser.username,
          isPremium: tgUser.is_premium,
          initData: WebApp.initData,
        },
        {
          headers: { "x-api-key": APIKey },
        }
      );
      return updatedUser.data;
    } catch (error) {
      console.error("Error updating user info:", error);
      return null;
    }
  }
};
